import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { isEmpty } from 'lodash';
import { Destroyer } from 'src/app/core/abstract/destroyer';
import { ServerTextFilterValue } from 'src/app/core/models/filters.models';

@Component({
  selector: 'craft-filter-text',
  templateUrl: './craft-filter-text.component.html',
  styleUrls: ['./craft-filter-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CraftFilterTextComponent extends Destroyer implements OnChanges {
  @Input() public buttonText: string;
  @Input() public selectedValue: ServerTextFilterValue;

  @Output() public apply = new EventEmitter<ServerTextFilterValue | undefined>();
  @Output() public remove = new EventEmitter<void>();

  constructor() {
    super();
  }

  @HostBinding('class.active')
  public get isAnySelect() {
    return !isEmpty(this.selectedValue);
  }

  public get buttonExtendedText(): string {
    const val = this.selectedValue;
    const text = typeof val?.text === 'string' ? val.text : '';
    const noVal = val?.noValue ? 'no value' : '';
    const extraText = text || noVal;
    return extraText ? `${this.buttonText}: ${extraText}` : this.buttonText;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedValue && !changes.selectedValue.currentValue) {
      this.selectedValue = {};
    }
  }

  public setNoValue(change: MatCheckboxChange) {
    this.selectedValue.noValue = change.checked;
  }

  public setTextValue(text: string) {
    this.selectedValue.text = text;
  }

  public resetText(change: MatCheckboxChange) {
    if (!change.checked) {
      this.selectedValue.text = void 0;
    }
  }

  public removeFilter(e: MouseEvent) {
    e.stopPropagation();
    this.remove.emit();
  }

  public clearSelected(e?: MouseEvent) {
    this.selectedValue = {};
    this.applyFilters(e);
  }

  public applyFilters(e?: MouseEvent) {
    e?.stopPropagation();
    this.apply.next(this.selectedValue);
  }
}
